
import { Component, Prop, Vue } from 'vue-property-decorator';
import TagRepositoryInterface, { TagInterface } from '@/services/QA/tag/interfaces';

@Component({
  inject: [
    'tagRepository',
  ],
})
export default class DeleteTagDialog extends Vue {
  @Prop() public tag!: TagInterface;
  private visible: boolean = true;
  private tagRepository!: TagRepositoryInterface;

  get message(): string {
    return `Are you sure you want to delete ${this.tag.label}?`;
  }

  private async deleteTag(): Promise<void> {
    try {
      await this.tagRepository.deleteTag(this.tag.id);
      this.$successDialog.show('Tag deleted successfully');
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message);
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
